
export enum Comparison {
    Equals = 1,
    NotEquals = 2,
    LessThan = 3,
    LessThanOrEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
    Contains = 7
}

export enum BooleanOperator {
    None = 1,
    And = 2,
    Or = 3
}

export enum OrderByDirection {
    Asc = 1,
    Desc = 2
}

export interface PropertyFilter {
    comparison: Comparison;
    field: string;
    value: string;
}

export interface PropertyFilterSet {
    operator?: BooleanOperator;
    filterSets?: PropertyFilterSet[];
    filters?: PropertyFilter[];
}

export interface PageRequest {
    pageNumber?: number;
    pageSize?: number;
    orderBy?: {
        field: string;
        direction: OrderByDirection;
    };
    filterSet?: PropertyFilterSet;
}

export interface PagedResponse<T> {
    totalCount: number;
    result: T[];
}
